import React from "react";
import ScrollToTop from "../components/scroll-to-top";
import SEO from "../components/seo";
import ContactContainer from "../containers/contact";
import Layout from "../layouts";
import Header from "../layouts/header";

const ContactPage = () => {
    return (
        <React.Fragment>
            <Layout>
                <SEO
                    title="Contact Muhammad Sajid"
                    description="Get in touch with Muhammad Sajid for web development, cybersecurity consultation, or collaborative projects."
                    keywords="Contact Muhammad Sajid, Hire Developer, Security Consultant, Collaboration"
                />
                <div className="main-wrapper">
                    <Header />
                    <ContactContainer />
                </div>
                <ScrollToTop />
            </Layout>
        </React.Fragment>
    );
};

export default ContactPage;
